import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class InspirationsSlider {
	constructor($el) {
		this.$el = $el;
        // this.mode = this.$el[0].hasAttribute('data-mode') ? this.$el.attr('data-mode') : 'handheld';

		this.options = {
            optionsMobile: {
                autoPlay: false,
                pageDots: true,
                wrapAround: true,
                prevNextButtons: false,
                freeScroll: true,
                fade: false,
                adaptativeHeight: false,
                imagesLoaded: true,
                cellAlign: 'left',
                cellSelector: ".inspirations__item",
                // setGallerySize: false
            },
            optionsDesktop: {
                autoPlay: false,
                pageDots: true,
                wrapAround: true,
                prevNextButtons: true,
                freeScroll: true,
                fade: false,
                adaptativeHeight: false,
                imagesLoaded: true,
                cellAlign: 'left',
                cellSelector: ".inspirations__item",
                groupCells: 2,
                // setGallerySize: false
            }
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.inspirations__item');
        this.slidesCount = this.$slides.length;

        // console.log('Nombre de slides Inspiration: ' + this.slidesCount);

        if (document.body.clientWidth < 700 && this.slidesCount > 1) {
            this.slider = new Flickity(this.$el[0], this.options.optionsMobile);
            // console.log('slider mobile');
        } else if (document.body.clientWidth >= 700 && document.body.clientWidth < 1200 && this.slidesCount > 2) {
            this.slider = new Flickity(this.$el[0], this.options.optionsDesktop);
            // console.log('slider tablet');
        } else if (document.body.clientWidth >= 1200 && document.body.clientWidth < 1400 && this.slidesCount > 3) {
            this.slider = new Flickity(this.$el[0], this.options.optionsDesktop);
            // console.log('slider desktop');
        } else if (document.body.clientWidth >= 1400 && this.slidesCount > 4) {
            this.slider = new Flickity(this.$el[0], this.options.optionsDesktop);
            // console.log('slider medium-large desktop +1400');
        } else {
            // console.log('no inspiration slider');
        } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth < 700 && this.slidesCount > 1) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options.optionsMobile);
            // console.log('slider resize mobile');
        } else if (document.body.clientWidth >= 700 && document.body.clientWidth < 1200 && this.slidesCount > 2) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options.optionsDesktop);
            // console.log('slider resize tablet');
        } else if (document.body.clientWidth >= 1200 && document.body.clientWidth < 1400 && this.slidesCount > 3) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options.optionsDesktop);
            // console.log('slider resize desktop');
        } else if (document.body.clientWidth >= 1400 && this.slidesCount > 4) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options.optionsDesktop);
            // console.log('slider resize medium-large desktop +1400');
        } else {
            this._destroy();
            // console.log('no inspiration slider');
        }
    }

}

export default InspirationsSlider;
